import $ from 'jquery';
import { findFileName } from './lib/helpers';

findFileName();

$(document).on( 'submit', '.wpcf7-form', function() {
    var $submit =  $(this).find('[type=submit]');
  
    $submit.attr('disabled', true)
      .data( 'original-text', $submit.text() )
      .text( 'Sending…' );
  });
  
  $(document).on( 'wpcf7submit', '.wpcf7', function (e) {
    var $submit =  $(this).find('[type=submit]');
  
    $submit.removeAttr('disabled');
  
    if( $submit.data( 'original-text' ) ) {
      $submit.text( $submit.data( 'original-text' ) );
    }
  });
  